module.exports = {
    APPNEXUS_FEATURE: 'appnexus_tags',
    GOOGLE_ADS_FEATURE: 'google_ads',
    GOOGLE_ADS_SETTINGS: 'google_ads_settings',
    NATIVE_ADS_FEATURE: 'native_ads',
    DESKTOP_PREFIX: 'DSK-',
    MOBILE_PREFIX: 'MOB-',
    DESKTOP_SETTING_GROUP_KEY: 'desktop',
    MOBILE_SETTING_GROUP_KEY: 'mobile',
};